export default "__VITE_ASSET__CszRbvV4__"